module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Lost-Treasures-of-the-Maya.6b38935.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Lost-Treasures-of-the-Maya.jpg
// module id = 1fIr
// module chunks = 0